<template>
    <div>
        <b-card no-body>
            <b-card-header>
                <h5>Pagamentos Mensais</h5>
            </b-card-header>
            <b-card-body>
                <b-row>
                    <b-col sm="12" md="2">
                        <b-form-group>
                            <strong>
                                <label>Ano Competência</label>
                            </strong>
                            <b-form-select
                                :options="anos"
                                v-model="anoPainel"
                            ></b-form-select>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col sm="12">
                        <b-tabs>
                            <b-tab title="SGTEC"
                                v-if="$temAcessoView('REL-PAGMEN-01')"
                            >
                                <tab-pagamentos-mensais
                                    :estatisticas="estatisticasSgtec"
                                    :ano="anoPainel"
                                    v-if="estatisticasSgtec"
                                ></tab-pagamentos-mensais>
                            </b-tab>
                            <b-tab title="SGF"
                                v-if="$temAcessoView('REL-PAGMEN-02')"
                            >
                                <tab-pagamentos-mensais
                                    :estatisticas="estatisticasSgf"
                                    :ano="anoPainel"
                                    v-if="estatisticasSgf"
                                ></tab-pagamentos-mensais>
                            </b-tab>
                            <b-tab title="GESCON"
                                v-if="$temAcessoView('REL-PAGMEN-03')"
                            >
                                <tab-pagamentos-mensais
                                    :estatisticas="estatisticasGescon"
                                    :ano="anoPainel"
                                    v-if="estatisticasGescon"
                                ></tab-pagamentos-mensais>
                            </b-tab>
                            <b-tab title="Despesas Gerais"
                                v-if="$temAcessoView('REL-PAGMEN-04')"
                            >
                                <tab-pagamentos-mensais
                                    :estatisticas="estatisticasDespGer"
                                    :ano="anoPainel"
                                    v-if="estatisticasDespGer"
                                ></tab-pagamentos-mensais>
                            </b-tab>
                        </b-tabs>
                    </b-col>
                </b-row>
            </b-card-body>
        </b-card>
        <router-view></router-view>
    </div>
</template>

<script>
import painelServicos from './../PainelServicos'
import TabPagamentosMensais from './TabPagamentosMensais.vue'

export default {
    components: {
        TabPagamentosMensais
    },

    data() {
        return {
            estatisticasSgtec: null,
            estatisticasSgf: null,
            estatisticasGescon: null,
            estatisticasDespGer: null,
            anoPainel: null,
            anos: []
        }
    },

    methods: {
        obterEstatisticasPorAno() {
            this.$store.dispatch('addRequest')
            painelServicos.obterEstatisticasPagamentosMensais(this.anoPainel).then(response => {
                if (response) {
                    if (response.success) {
                        this.estatisticasSgtec = response.data.estatisticasSgtec
                        this.estatisticasSgf = response.data.estatisticasSgf
                        this.estatisticasGescon = response.data.estatisticasGescon
                        this.estatisticasDespGer = response.data.estatisticasDespGer
                    } else {
                        this.$toast.error(
                            'Não foi possivel obter as estatisticas dos pagamentos',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            }) 
        },

        obterAnosPainel() {
            this.$store.dispatch('addRequest')
            painelServicos.obterAnosPainel().then(response => {
                if (response) {
                    if (response.success 
                        && response.data != null
                        && response.data.length > 0
                    ) {
                        this.anos = response.data
                        this.anoPainel = this.anos[0]
                        this.obterEstatisticasPorAno()
                    } else {
                        this.$toast.error(
                            'Não foi possivel obter os anos disponiveis',
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    mounted() {
        this.obterAnosPainel()
    },

    computed: {
        mostrarPainel() {
            return this.$route.name == 'Painel_PagamentosMensais'
        }
    },

    watch: {
        anoPainel() {
            this.obterEstatisticasPorAno()
        }
    }
}
</script>